import React from 'react';
import { Button } from '@spothero/ui';
import { styles } from '../styles';
export const FilterButtonBase = ({ children, onClick, testid, ...props }) => (<Button {...styles} _hover={{
        backgroundColor: 'transparent',
        borderColor: 'black',
    }} gap="1" data-testid={testid} onClick={onClick} {...props}>
        {children}
    </Button>);
